import React, { useState, useEffect } from "react";
import {
  Badge,
  Card,
  Col,
  Row,
  Form,
  Button,
  Dropdown,
  Alert,
  Spinner,
  Modal,
  Nav,
  OverlayTrigger,
  Tooltip,
  ButtonGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import CustomNavbar from "../../../components/CustomNavbar";
import CustomPagint from "../../../components/CustomPagint";
import CustomTable from "../../../components/CustomTable";
import {
  getWorkflows,
  saveWorkflow,
  copyWorkFlow,
  editWorkflow,
  deleteWorkflow,
} from "../../../redux/on&offBoarning/workflow/actions";
import SidebarConfig from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";
import WorkFlowEmployees from "../../../components/OnBoarding_OffBoarding/WorkFlowEmployees";
import ProgressIndicator from "../../../components/ProgressIndicator";
import config from "../../../config";
const WorkFlow = () => {
  //* Effects
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [item, setItem] = useState(null);
  const [validated, setValidated] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [filter, setFilter] = useState({ id: "nombre", desc: "Nombre" });
  const [search, setSearch] = useState("");
  const [showSidebard, setShowSideBar] = useState(false);
  //const [validatedDate, setValidateDate] = useState(false);
  const [showEmployeesModal, setShowEmployeesModal] = useState(false);
 
  //* Redux
  const {
    loading,
    loadingCopyWorkFlow,
    saveLoading,
    workflows,
    workflowLength,
    formErrors,
    error,
  } = useSelector((store) => store.workflow);
  const { userId } = useSelector((store) => store.auth);
  //paginación
  const pages = Math.ceil(workflowLength / limit);

  //* Variables
  const { workFlowTypes } = config.offonboarnig;
  workflows.sort((a, b) => (a.nombre > b.nombre ? 1 : -1));

  const dispatch = useDispatch();
  const filters = [
    { id: "nombre", desc: "Nombre" },
    { id: "descripcion", desc: "Descripción" },
    { id: "creador_codigo", desc: "Código de creador" },
    { id: "creador_nombre", desc: "Nombre de creador" },
  ];
  const columns = [
    {
      id: "countBlog",
      Header: "N°. tareas",
      Cell: (value) => (
        <Badge
          variant={value.row.original.workflow_bloques ? "info" : "warning"}
        >
          {value.row.original.workflow_bloques
            ? value.row.original.workflow_bloques.length
            : 0}
        </Badge>
      ),
    },
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Fecha de inicio",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_inicio).format("DD/MM/YYYY"),
    },
    {
      Header: "Fecha de fin",
      Filter: "",
      Cell: (value) => (
        <div
          style={{ width: "8.9rem" }}
          className={`rounded-pill text-white text-center px-2 ${
            moment(moment().format("YYYY-MM-DD")).diff(
              moment(value.row.original.fecha_fin),
              "days"
            ) > 0
              ? "bg-danger"
              : moment(value.row.original.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 1
              ? "bg-info"
              : "bg-success"
          }`}
        >
          {moment(value.row.original.fecha_fin).format("DD/MM/YYYY")}
        </div>
      ),
    },
    // {
    //   Header: 'Estado',
    //   Filter: '',
    //   Cell: value => (<div className="d-flex justify-content-between"><div className={`rounded-pill ${value.row.original.estado ? 'bg-success' : 'bg-danger'}`} style={{width: '3rem', height: '1rem', marginRight: '.6rem'}}></div><Form.Check disabled inline checked={value.row.original.estado}  /></div>)
    // },
    {
      Header: "Creador",
      Filter: "",
      Cell: (value) =>
        `${value.row.original.datos_creador[0].first_name} ${value.row.original.datos_creador[0].last_name}`,
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() =>
              handleEditWorkFlow(value.row.original, value.row.index)
            }
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() =>
              handleDeleteWorkFlow(value.row.original.id, value.row.index)
            }
          >
            <i className="material-icons">close</i>
          </Button>
          <Link
            to={`/workflow-block/${value.row.original.id}/${value.row.original.nombre}/1`}
            className="btn btn-default btn-sm"
          >
            <i className="material-icons">grid_view</i>
          </Link>
          <Button
            size="sm"
            className="text-success"
            variant="link"
            type="button"
            onClick={() => handleWorkFlowEmployee(value.row.original)}
          >
            <i className="material-icons">group_add</i>
          </Button>
          <Button
            size="sm"
            className="text-primary"
            variant="link"
            type="button"
            onClick={() => handleCopyWorkFlow(value.row.original.id)}
          >
            <i className="material-icons">copy_all</i>
          </Button>
        </div>
      ),
    },
  ];

  //* Methods
  const getPlantWorkFlows = (offs = offset, lim = limit, filt = search) =>
    dispatch(
      getWorkflows({
        offset: offs,
        limit: lim,
        tipo_busqueda: filter.id,
        filter: filt,
      })
    );
  useEffect(() => {
    getPlantWorkFlows();
  }, []);

  /*Paginación*/
  /*const prev = () => {
    if(currentPage <= 0)
      setCurrentPage(0);
    else
      setCurrentPage(currentPage - 1);

    const oOffset = offset - limit;
    setOffset(oOffset);
    
    dispatch(getWorkflows({
      offset: oOffset,
      limit: limit,
      tipo_busqueda: filter.id,
      filter: search
    }));
  }

  const next = () => {
    if (currentPage >= pages)
      setCurrentPage(pages);
    else
      setCurrentPage(currentPage + 1);
    const oOffset = offset + limit;
    setOffset(oOffset);
    dispatch(getWorkflows({
      offset: oOffset,
      limit: limit,
      tipo_busqueda: filter.id,
      filter: search
    }));
  }

  const last = () => {
    setCurrentPage(pages);
    const oOffset = (pages * limit) - limit;
    setOffset(oOffset);
    dispatch(getWorkflows({
      offset: oOffset,
      limit: limit,
      tipo_busqueda: filter.id,
      filter: search
    }));
  }

  const first = () => {
    setCurrentPage(1);
    const oOffset = 0;
    setOffset(oOffset);
    dispatch(getWorkflows({
      offset: oOffset,
      limit: limit,
      tipo_busqueda: filter.id,
      filter: search
    }));
  }

  const onChangeLimit = value => {
    const oLimit = parseInt(value);
    const oOffset = 0;
    setLimit(oLimit);
    setOffset(oOffset);
    setCurrentPage(1);
    dispatch(getWorkflows({
      offset: oOffset,
      limit: oLimit,
      tipo_busqueda: filter.id,
      filter: search
    }));
  };*/
  /*fin paginación*/

  const onSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getPlantWorkFlows(oOffset, limit, e.target.filter.value);
    // dispatch(getWorkflows({
    //   offset: offset,
    //   limit: limit,
    //   tipo_busqueda: filter.id,
    //   filter: e.target.filter.value
    // }));
  };

  const handleCreateWorkFlow = () => {
    setEdit(false);
    setItem(null);
    setShow(true);
    setValidated(false);
  };

  const handleEditWorkFlow = (item, rowIndx) => {
    setEdit(true);
    setItem(item);
    setShow(true);
    setValidated(false);
    setRowIndex(rowIndx);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

   
  // if (moment(e.target.datest.value) > moment(e.target.datef.value)){
    //   setValidated(false);
    //   setValidateDate(true);
    //   return;
    // }

    const req = {
      nombre: e.target.nombre.value,
      descripcion: e.target.desc.value,
      tipo_workflow: e.target.workflowType.value,
      // fecha_inicio: moment(e.target.datest.value).format('YYYY-MM-DD'),
      // fecha_fin: moment(e.target.datef.value).format('YYYY-MM-DD'),
      estado: false,
      creador: userId,
    };

    if (edit) {
      dispatch(editWorkflow(req, rowIndex, item.id));
    } else {
      dispatch(saveWorkflow(req));
    }
    setShow(false);
  };

  const handleDeleteWorkFlow = (id, rowIndx) => {
    if (window.confirm("¿Estás seguro de querer eliminar este WorkFlow?")) {
      dispatch(deleteWorkflow(id, rowIndx));
    }
  };

  const handleWorkFlowEmployee = (item) => {
    setItem(item);
    setShowEmployeesModal(true);
  };

  const handleCopyWorkFlow = (id) => {
    const req = {
      plantilla: id,
    };
    dispatch(copyWorkFlow(req));
  };

  const seeAll = () => {
    const oSearch = "";
    setSearch(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getPlantWorkFlows(oOffset, limit, oSearch);
  };

  const onShowSidebar = () => setShowSideBar(showSidebard ? false : true);
  const handleClose = () => setShow(false);
  const handleCloseEmployeesModal = () => setShowEmployeesModal(false);

  return (
    <div className="p-lg-2 p-md-2">
      <CustomNavbar />
      <ProgressIndicator isLoading={loadingCopyWorkFlow} />
      <WorkFlowEmployees
        item={item}
        show={showEmployeesModal}
        handleClose={handleCloseEmployeesModal}
      />
      <SidebarConfig show={showSidebard} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <Form onSubmit={onSearch}>
            <Row className="justify-content-start align-items-center flex-nowrap">
              <Col xs="auto" className="px-1">
                <h4 className="m-0 ml-3">
                  Plantillas de workFlows <i className="material-icons">star</i>
                </h4>
              </Col>
              <Col xs="auto" className="px-1">
                <Button
                  onClick={handleCreateWorkFlow}
                  variant="primary"
                  className="btn btn-sm rounded-pill font-weight-bold"
                >
                  <i className="material-icons">add</i> Crear nuevo workflow
                </Button>
              </Col>
              <Col xs="auto">
                <Form.Control
                  id="filter"
                  name="filter"
                  //onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar / Filtrar WorkFlow"
                  className="rounded-pill form-control-sm"
                  type="search"
                ></Form.Control>
              </Col>
              <Col xs="auto" className="px-1">
                <ButtonGroup className="d-flex align-items-center">
                  <Button
                    onClick={() => seeAll()}
                    variant="light"
                    size="sm"
                    className="mr-1"
                  >
                    <i className="material-icons">visibility</i>
                  </Button>

                  <Dropdown className="mr-2">
                    <Dropdown.Toggle variant="primary" className="btn-sm font">
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filters.map((item) => (
                        <Dropdown.Item
                          onClick={() => setFilter(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  {filter.desc}
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
          <section className="my-2 px-2">
            <hr />
            <Nav className="justify-content-start">
              <Nav.Item className="mr-3">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Monitor de OnBoarding</Tooltip>}
                >
                  <Link to="/Monitor/OnBoarding/1">
                    <i className="material-icons text-muted">airplay</i>
                  </Link>
                </OverlayTrigger>
              </Nav.Item>
              <Nav.Item>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Monitor de OnOffBoarding</Tooltip>}
                >
                  <Link to="/Monitor/OffBoarding/2">
                    <i className="material-icons text-muted">reset_tv</i>
                  </Link>
                </OverlayTrigger>
              </Nav.Item>
            </Nav>
          </section>

          {!!error && (
            <Alert variant="danger" className="mt-4 mb-1">
              {error}
            </Alert>
          )}
          <Card className="border-0 mt-2">
            <Card.Body className="px-0">
              {loading ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : workflows.length > 0 ? (
                <>
                  <CustomTable columns={columns} data={workflows} />
                  <CustomPagint
                    limit={limit}
                    setLimit={setLimit}
                    offset={offset}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    dataLenght={workflowLength}
                    pages={pages}
                    pagFunc={getPlantWorkFlows}
                  />
                </>
              ) : (
                <Alert variant="info">
                  Aún no hay procesos registrados, comienza agregando algunos.
                </Alert>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? `Editar WorkFlow ${item.nombre}` : "Crear WorkFlow"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {formErrors && (
              <Alert variant="danger">
                <h6 className="font-weight-bold">
                  Hemos experimentado los suguientes errores:
                </h6>
                {Array.isArray(formErrors) ? (
                  <ul className="list-unstyled">
                    {formErrors.map((item, inx) => (
                      <li key={inx}>{item}</li>
                    ))}
                  </ul>
                ) : (
                  formErrors
                )}
              </Alert>
            )}
            <Form.Group className="mb-3">
              <Form.Label className="ml-2">Nombre</Form.Label>
              <Form.Control
                className="rounded-pill"
                id="nombre"
                name="nombre"
                type="text"
                placeholder="Nombre"
                required
                defaultValue={item ? item.nombre : null}
              />
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="workflowType">
              <Form.Label className="ml-2">Tipo de WorkFlow</Form.Label>
              <Form.Control
                as="select"
                name="workflowType"
                className="rounded-pill"
                required
                defaultValue={item ? item.tipo_workflow : null}
                placeholder="País de nacimiento"
              >
                {workFlowTypes.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.desc}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="ml-2">Descripción</Form.Label>
              <Form.Control
                as="textarea"
                id="desc"
                name="desc"
                type="text"
                placeholder="Descripción"
                required
                defaultValue={item ? item.descripcion : null}
              />
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group className="mb-3">
            <Form.Label className="ml-2">Fecha de inicio</Form.Label>
            <Form.Control
              className={`rounded-pill ${validatedDate ? 'is-invalid' : null}`}
              id="datest" 
              name="datest" 
              type="date" 
              placeholder="Fecha de inicio"
              required
              defaultValue={item ? item.fecha_inicio: null}  />
            <Form.Control.Feedback type="invalid">
              <ul className="list-unstyled">
                <li>**Campo requerido</li>
                <li>**La fecha de inicio no puede ser mayor que la fecha de fin.</li>
              </ul>
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="ml-2">Fecha de fin</Form.Label>
            <Form.Control
              className={`rounded-pill ${ validatedDate ? 'is-invalid' : null}`}
              id="datef" 
              name="datef" 
              type="date" 
              placeholder="Fecha de fin"
              required
              defaultValue={item ? item.fecha_fin: null}  />
            <Form.Control.Feedback type="invalid">
              <ul className="list-unstyled">
                <li>**Campo requerido</li>
                <li>**La fecha de fin no puede ser menor que la fecha de inicio.</li>
              </ul>
            </Form.Control.Feedback>
          </Form.Group> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoading}
              variant="primary"
              type="submit"
             
            >
              {saveLoading ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      
    </div>
  );
};

export default WorkFlow;
